import { translatePixels } from "../mergeStyles";

type BreakpointType = "<" | "<=" | ">" | ">=";

/** should only be used in `theme` to generate breakpoints */
export const createMediaQuery = (
  breakpoint: number | string,
  type: BreakpointType = "<",
) => `@media (width ${type} ${translatePixels(breakpoint)})`;
